<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "info-box",
  };
</script>

<style scoped>

  div {
    @apply block w-full pt-4 pb-16 px-5 flex text-center text-grey-text font-light bg-grey-bg text-xs ;
  }


</style>
